import { useMemo } from 'react';
import { ecorpResources } from '@command-center/admin-ecorp';
import { useNavigate, useSearchParams } from 'react-router-dom';
import type { PortalRecord } from '../api';
import { recents } from '../lib';
import { ResourceView } from '../ResourceView';

export function ProjectsView({
  onContext,
  onNewProject,
}: {
  onContext(value: Record<string, unknown>): void;
  onNewProject(): void;
}) {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const initialFilter = useMemo(() => {
    const field = params.get('filterField');
    const value = params.get('filterValue');
    return field && value ? { field, value } : undefined;
  }, [params]);
  const recent = recents.list();

  function open(item: PortalRecord) {
    recents.push(item.id, String(item.fields['Project Name'] ?? item.id));
    navigate(`/projects/${item.id}`);
  }

  return (
    <div className="space-y-4">
      {recent.length > 0 && (
        <div className="flex flex-wrap items-center gap-1.5 text-sm">
          {recent.slice(0, 5).map((item) => (
            <button
              key={`recent-${item.id}`}
              className="rounded-full border px-2.5 py-1 text-xs text-muted-foreground transition hover:border-primary/50 hover:text-foreground"
              onClick={() => navigate(`/projects/${item.id}`)}
            >
              {item.label}
            </button>
          ))}
        </div>
      )}
      <ResourceView
        resource={ecorpResources.projects}
        onContext={onContext}
        onOpenRecord={open}
        initialFilter={initialFilter}
        onCreate={onNewProject}
      />
    </div>
  );
}
